export const UPDATE_USER = "UPDATE_USER";
export const GET_SELECTED_USER = "UPDATE_USER";
export const CREATE_USER='CREATE_USER';
export const GET_ACTION='GET_ACTION '
